var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuocIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#F06866"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12975_180498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3124 8.45385C20.7109 7.52069 18.6554 8.06293 17.7222 9.66445L13.9391 16.1714L10.156 22.6657C9.22284 24.2672 9.76508 26.3227 11.3666 27.2559C12.9681 28.189 15.0236 27.6468 15.9568 26.0453L19.7399 19.551L23.523 13.044C24.4561 11.4425 23.9139 9.38702 22.3124 8.45385ZM23.1699 12.8423L19.3994 19.324L14.3048 16.3605L18.0753 9.87882C18.4788 9.18525 19.1093 8.70606 19.8786 8.5043C20.6352 8.30253 21.4296 8.41602 22.1106 8.80694C23.5104 9.62662 23.9895 11.4299 23.1699 12.8423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2845 24.0151C25.9945 26.0453 23.9768 26.5371 22.6149 26.5245C20.5847 26.5119 18.9453 25.4022 18.9453 24.0151C18.9453 23.9898 18.9453 25.3139 18.9453 25.4779C18.9453 26.865 20.5847 27.9873 22.6149 27.9873C24.6452 27.9873 26.2845 26.865 26.2845 25.4779C26.2845 25.3139 26.2971 23.9646 26.2845 24.0151Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1079 23.5613C25.9944 22.2498 24.3929 21.2031 22.4383 21.2031C22.2743 21.2031 22.123 21.2157 21.9717 21.2283L22.6905 22.6785L24.2794 25.8942V25.9068C25.3765 25.478 26.1205 24.6584 26.1205 23.7252C26.1079 23.6748 26.1079 23.6117 26.1079 23.5613Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4726 26.1211L21.7324 22.6028L21.1397 21.4048C19.9796 21.8083 19.1599 22.6154 19.1221 23.5612C19.1221 23.5864 19.1221 23.6116 19.1221 23.6494C19.1221 25.0366 20.7614 26.1589 22.7917 26.1589C23.0187 26.1715 23.2457 26.1589 23.4726 26.1211Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12975_180498"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.5952,
    height: 20,
    fill: "white",
    transform: "translate(9.70215 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuocIcon);
export default __webpack_public_path__ + "static/media/DuocIcon.64e833d3.svg";
export { ForwardRef as ReactComponent };